import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import config from "constants/config";
import { Tooltip } from "@paylixecommerce/shared/components";
import { getUserSettings } from "services/auth/actions";

import "./index.scss";

const Item = ({ disabled, setGateWays, name, label, gateways }) => {

    let tooltip;
    if (name === "USDC" || name === "USDT" || name === "PLZ" || name === "DAI" || name === "SHIB" || name === "PEPE" || name === "APE" || name === "WETH") {
        tooltip = "We will automatically display the available blockchains based on your cryptocurrency address configuration in your settings.";
    }

    let normalizedGateways = {};

    Object.keys(gateways)
        .map(g => g.split(":")[0])
        .filter((g, index, self) => self.indexOf(g) === index)
        .map(g => normalizedGateways[g] = gateways[g]);

    return <label htmlFor={name} className={`payment-checkbox ${Object.keys(normalizedGateways).includes(name) && normalizedGateways[name] ? "active" : ""} ${disabled ? "disabled" : ""}`}>
        <input
            type="checkbox"
            id={name}
            name={name}
            disabled={disabled ? 'disabled' : ''}
            checked={normalizedGateways[name]}
            onChange={(e) => setGateWays(`${name}`, e.target.checked)}
        />
        <span>
			<span style={(name === "USDC" || name === "USDT" || name === "PLZ" || name === "DAI" || name === "SHIB" || name === "PEPE" || name === "APE" || name === "WETH") ? { justifyContent: "flex-start" } : {}}>
				{label}

                {tooltip &&
                    <Tooltip tooltipText={tooltip} name={`${name}-tooltip`}>
                        <span>
                            <i className="fa-regular fa-info-circle mx-1" style={{ color: "var(--black9)", fontSize: 12 }} />
                        </span>
                    </Tooltip>
                }
			</span>

			<img src={config.PAYMENT_ICONS[name]} width={20} height={20} alt={name} style={{ borderRadius: 5 }}/>
		</span>
    </label>
};


const Payment = ({ availableGateways, setGateways, gateways }) => {

    let CRYPTOS = ["BITCOIN", /* "BITCOIN_LN", */ "ETHEREUM", "LITECOIN", "USDT", "USDC", "USDC_NATIVE", "TRON", "BINANCE_COIN", /*"BINANCE",*/ "SOLANA", "POLYGON", /* "NANO", */ "MONERO", "BITCOIN_CASH", /* "RIPPLE", "CONCORDIUM", "CRONOS", "APE", "PEPE", "WETH", */ /*"DAI", "SHIB"*/];
    let FINANCES = ["STRIPE", "PAYPAL", "SKRILL", "PERFECT_MONEY"];

    const [isCustomCoinsReady, setCustomCoinsReady] = useState(false);
    const [customCoins, setCustomCoins] = useState([]);
    const { profile } = useSelector(({ auth }) => auth);
    const hasSubscription = profile && profile.subscription && profile.subscription.id;
    const dispatch = useDispatch();

    const setGateWays = (value, isChecked) => setGateways({ ...gateways, [value]: isChecked });
    const toggleAllGateways = (data) => setGateways(data);

    if(hasSubscription) {
        FINANCES.push("CASH_APP");
    }

    // let showCustom = !(customCoins.includes("PLZ:TRC20") || customCoins.includes("PLZ:BEP20")) ? false : true; // Custom token disabled - no API support
    let showCustom = false; // PLZ tokens disabled

    useEffect(() => {
        dispatch(getUserSettings())
            .then(({ data }) => setCustomCoins(data.settings.shop.custom_coins))
            .finally(() => setCustomCoinsReady(true))
    }, []);

    if(availableGateways) {
        CRYPTOS = CRYPTOS.filter(gateway => availableGateways.includes(gateway));
        FINANCES = FINANCES.filter(gateway => availableGateways.includes(gateway));
        // showCustom = availableGateways.includes("PLZ") ? true : false; // PLZ tokens disabled
        showCustom = false;
    }

    const isAllCryptoConnected = CRYPTOS.every((v) => Object.keys(gateways).includes(v) && gateways[v]);
    const isAllFinanceConnected = FINANCES.every((v) => Object.keys(gateways).includes(v) && gateways[v]);

    if(!isCustomCoinsReady) {
        return null
    }
    return <div>
        <div className={!FINANCES.length ? "d-none" : ""}>
            <div className="payments-title">
                <div className="paylixecommerce-label">Finance</div>

                <div className="switcher-container">
                    <label className="switcher ml-0">
                        <input type="checkbox" id="finance-all" name="finance-all"
                               checked={isAllFinanceConnected}
                               onChange={() => {

                                   toggleAllGateways({
                                       ...FINANCES.reduce((acc, finance) => ({ ...acc, [finance]: !isAllFinanceConnected }), {}),
                                       ...CRYPTOS.reduce((acc, crypto) => ({ ...acc, [crypto]: gateways[crypto] }), {})
                                   })
                               }}
                        />
                        <span className="switcher-slider" />
                    </label>
                    <label htmlFor="finance-all" className="switcher-label">
                        <div className="paylixecommerce-label" style={{ display: "block", marginBottom: 0 }}>Toggle All</div>
                    </label>
                </div>

            </div>

            <div className="payments-container mb-4">
                {FINANCES.map((c, key) => (
                    <Item key={key} setGateWays={setGateWays} disabled={c === "CASH_APP" ? !hasSubscription : false} gateways={gateways} name={c} label={config.PAYMENT_FULL_NAME[c]} />
                ))}
                {/*<Item setGateWays={setGateWays} gateways={gateways} name="STRIPE" label="Stripe"/>*/}
                {/*<Item setGateWays={setGateWays} gateways={gateways} name="PAYPAL" label="PayPal"/>*/}
                {/*<Item disabled={!hasSubscription} setGateWays={setGateWays} gateways={gateways} name="CASH_APP" label="Cash App"/>*/}
                {/*<Item setGateWays={setGateWays} gateways={gateways} name="SKRILL" label="Skrill"/>*/}
                {/*<Item setGateWays={setGateWays} gateways={gateways} name="PERFECT_MONEY" label="Perfect Money"/>*/}
            </div>
        </div>

        <div className={!CRYPTOS.length ? "d-none" : ""}>
            <div className="payments-title">
                <div className="paylixecommerce-label">Crypto</div>

                <div className="switcher-container">
                    <label className="switcher ml-0">
                        <input type="checkbox" id="crypto-all" name="crypto-all"
                               checked={isAllCryptoConnected}
                               onChange={() => {
                                   toggleAllGateways({
                                       ...FINANCES.reduce((acc, finance) => ({ ...acc, [finance]: gateways[finance] }), {}),
                                       ...CRYPTOS.reduce((acc, crypto) => ({ ...acc, [crypto]: !isAllCryptoConnected }), {})
                                   })
                               }}
                        />
                        <span className="switcher-slider" />
                    </label>
                    <label htmlFor="crypto-all" className="switcher-label">
                        <div className="paylixecommerce-label" style={{ display: "block", marginBottom: 0 }}>Toggle All</div>
                    </label>
                </div>

            </div>

            {/*<div className="payments-container-wrapper">*/}
                <div className="payments-container">
                    {showCustom && <Item setGateWays={setGateWays} gateways={gateways} name="PLZ" label="Plaentz Token"/>}

                    {CRYPTOS.map((c, key) => (
                        <Item key={key} setGateWays={setGateWays} gateways={gateways} name={c} label={c === "USDC_NATIVE" ? "USDC Native" : config.PAYMENT_FULL_NAME[c]} />
                    ))}
                </div>
                {/*<div className="payments-container-element" />*/}
            {/*</div>*/}
        </div>
    </div>
}

export default Payment;
